export const locale = {
  LISTS: {
  NoData: "Нет данных",
  NoDataFound: "Данные не найдены",
  NoDataFoundFor: "Данные для {a} не найдены",
  NoPhoneNumber: "Номер не найден",
  NoPostalCode: "Почтовый индекс не найден",
  AddANumber: "Ни один номер не добавлен.",
  City: "Город",
  AddedBefore: "Уже добавлено",
},
  dashboard_origin: "Панель управления",
  menu: "Меню",
  get_menu_again: "Получить меню заново",
  loading_error: {
    title: "Ошибка загрузки!",
    message:
      "Произошла ошибка при загрузке данных! Пожалуйста, попробуйте снова",
    text: "Повторить попытку",
  },
  copy_right: {
    year: "1404",
    text1:
      "Все материальные и интеллектуальные права на эту систему защищены и принадлежат рекламной компании",
    text2: "Лучшие предприниматели",
    text3: "Сехр Арад, любое копирование преследуется по закону.",
  },
  user: "Уважаемый пользователь",
  hi: "Привет",
  exit: "Выход",
  go_to_page: "Перейти на страницу",
  show: "Показать",
  until: "до",
  from: "от",
  page: "страница",
  notes: "Заметки",
  created_at: "Дата создания",
  registration: "Регистрация",
  edit_contact: "Редактировать контакт",
  cancel: "Отмена",
  edit: "Редактировать",
  delete: "Удалить",
  contact_info: "Контактная информация",
  add_birthday: "Добавить дату рождения",
  contacts: "Телефонные книги",
  last_updated_at: "Последнее обновление",
  added_to_contact: "Добавлено в контакты",
  contact_registered: "Ваш контакт не сохранён.",
  transaction: "Транзакция",
  write_message: "Написать сообщение",
  note_title: "Заголовок заметки",
  create_note: "Добавить заметку",
  are_you_sure_to_delete: "Вы уверены, что хотите удалить?",
  last_transaction: "Последние транзакции",
  your_balance: "Ваш баланс",
  no_transaction: "У вас ещё нет транзакций!",
  increase_balance: "Пополнить баланс",
  transaction_list: "Список транзакций",
  withdraw: "Вывод средств",
  decrease: "Вывод средств",
  deposit: "Пополнение",
  increase: "Пополнение",
  charge: "Пополнить кошелёк",
  refund: "Возврат средств",
  save: "Сохранить",
  reload: "Обновить список",
  shared: "Поделено",
  list: "Список",
  single_add: "Добавить по одному",
  mass_add: "Массовое добавление",
  excel_add: "Добавить из Excel",
  added_successfully: "Успешно добавлено",
  error_add_phone: "Ошибка при добавлении номера",
  group: {
    add: "Добавить новую группу",
    delete: "Удалить группу",
    edit: "Редактировать группу",
    first: "Сначала добавьте новую группу.",
  },
  successfully_deleted: "Успешно удалено",
  notification: {
    text: "Уведомления пользователя",
    new: "Новое сообщение",
    messages: "Сообщения",
    events: "События",
    no_new_message: "Нет новых сообщений!",
    show_all: "Показать все",
    no_new_event: "Нет новых событий!",
    go_to_user: "Перейти к пользователю",
    watched: "Просмотрено",
  },
  locking_for_service: "Какую услугу вы ищете?",
  service_name: "Введите название нужной услуги...",
  invite: {
    title: "Пригласите друзей в систему.",
    gift: "Подарок",
    get: "Получить.",
    phone: "Введите номер.",
    invite: "Пригласить!",
    got_it: "Понял",
    get_gift: "Получить подарок",
    success: "Приглашение успешно отправлено.",
    wrong_number: "Пожалуйста, введите правильный номер.",
  },
  ticker: {
    text: "Мы с вами в любой момент...",
    help: "Для связи с командой поддержки зарегистрируйте тикет",
    register: "Зарегистрировать тикет",
  },
  package: {
    title: "Активные пакеты",
    no: "У вас нет активных пакетов.",
    no_limit: "Неограниченная панель",
    day: "дневный",
    other: "другое",
    expiration: "Истекает ",
    expired: "Истёк ",
  },
  Loading: {
    Waiting: "Пожалуйста, подождите",
    Description: "Подождите несколько мгновений",
  },
  Questions: {
    Yes: "Да",
    No: "Нет",
  },
  Success: {
    Title: "Успешно",
    defaultActionText: "Понял",
  },
  Info: {
    Title: "Информация",
    defaultActionText: "Понял",
  },
  Warning: {
    Title: "Внимание",
    defaultActionText: "Понял",
  },
  Error: {
    Title: "Ошибка",
    defaultActionText: "Понял",
  },
  Wallet: {
    Title: "Недостаточно средств",
    defaultActionText: "Понял",
  },
  ConnectionLost: {
    Title: "Интернет-соединение потеряно",
    Subtitle: "Пожалуйста, проверьте подключение к интернету",
    Button: "Повторить",
  },
  emoji: "Эмодзи",
  text_suggest_free: "Консультант текста (бесплатно)",
  select_campaign: "Выбрать кампанию",
  short_link: "Короткая ссылка",
  text_suggest: "Консультант текста",
  select_emoji: "Выбрать эмодзи",
  default_text: "Текст по умолчанию",
  emoji_group: {
    "Smileys & Emotion": "Смайлики и эмоции",
    "People & Body": "Люди и тело",
    "Animals & Nature": "Животные и природа",
    "Food & Drink": "Еда и напитки",
    "Travel & Places": "Путешествия и места",
    Activities: "Активности",
    Objects: "Объекты",
    Symbols: "Символы",
    Flags: "Флаги",
  },
  table: {
    index: "№",
    title: "Заголовок",
    text: "Текст",
    select: "Выбрать",
    next: "Далее",
    previous: "Назад",
    rows_per_page: "Строк на странице",
    no_data: "Нет данных для отображения",
    search_placeholder: "Поиск",
  },
  modal: {
    success: "Успех",
  },
  actions: {
    remove: "Удалить",
    copyLink: "Копировать ссылку",
    operations: "Операции",
    edit: "Редактировать",
    delete: "Удалить",
    show: "Показать",
    accept: "Подтвердить",
    reject: "Отклонить",
    enable: "Активировать",
    download: "Скачать",
    deactive: "Деактивировать",
  },

  shortLink: {
    freeShorten: 'Сокращайте свои ссылки "бесплатно".',
    clickToSelect: "Нажмите на нужную ссылку, чтобы выбрать.",
    create: "Создать короткую ссылку",
    title: "Заголовок",
    titleHint: "Добавьте название для короткой ссылки.",
    link: "Ссылка",
    linkHint: "Введите нужную ссылку.",
    shortenedLink: "Сокращённая ссылка",
    clickCount: "Количество кликов",
    selectDomain: "Выбрать домен",
  },
  pagination: {
    next: "Далее",
    previous: "Назад",
    rowsPerPage: "Строк на странице",
    noData: "Нет данных для отображения",
    search: "Поиск",
  },
  validation: {
    titleRequired: "Заголовок обязателен",
    minLength4: "Минимум 4 символа",
    linkRequired: "Ссылка обязательна",
    mustIncludeHttps: "Должна включать https://",
    invalidLink: "Введите корректную ссылку.",
  },
  messages: {
    addedSuccessfully: "Успешно добавлено.",
    confirmDeleteShortLink: "Подтвердить удаление короткой ссылки?",
  },
  inputMenu: {
    text: "Текст",
    selectUserInfo: "Выбрать данные пользователя",
  },
  patternDialog: {
    title: "Выбор шаблона/кампании",
    change: "Изменить шаблон/кампанию",
    createPattern: "Зарегистрировать новый шаблон",
    createCampaign: "Зарегистрировать новую кампанию",
    tabs: {
      pattern: "Выбор шаблона",
      campaign: "Выбор кампании",
    },
    empty: "Шаблон не найден, сначала зарегистрируйте шаблон.",
    columns: {
      id: "ID",
      type: "Тип",
      pattern: "Шаблон",
      static: "Статический",
      title: "Заголовок",
      content: "Текст",
      status: "Статус",
      rejected: "Отклонено",
      approved: "Одобрено",
    },
    pagination: {
      next: "Далее",
      prev: "Назад",
      rowsPerPage: "Строк на странице",
      noData: "Нет данных для отображения",
      search: "Поиск",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "Выбранное сообщение:",
    REQUIRED_INPUTS: "Обязательные поля:",
    SELECTED_CAMPAIGN: "Выбранная кампания:",
    CAMPAIGN_ID: "ID",
    PRE_NAME: "Префикс",
    NAME: "Имя",
    MIDDLE_NAME: "Отчество",
    LAST_NAME: "Фамилия",
    POST_NAME: "Суффикс",
    ALIAS: "Псевдоним",
    COMPANY: "Компания",
    JOB_TITLE: "Должность",
    PHONE: "Телефон",
    BIRTHDAY: "Дата рождения",
    DESCRIPTION: "Описание",
  },
  CONTACT_GROUP: {
    LIST: "Список",
    ADD: "Добавить",
    SEARCH: "Поиск",
    INDEX: "№",
    ID: "ID",
    GROUP_NAME: "Название группы",
    PARENT: "Родитель",
    CREATE: {
      GROUP_NAME: "Название группы по умолчанию",
      PARENT_CATEGORY: "Родительская категория",
      ADD_GROUP: "Добавить группу",
      SUCCESS: "Группа по умолчанию успешно добавлена.",
      ERROR: "Ошибка при добавлении группы по умолчанию!",
      SEARCH: "Поиск",
      TITLE: "Заголовок",
      SEARCH_IN_TITLE: "Поиск по заголовку",
      FROM: "От",
      TO: "До",
      BIRTHDAY_FROM: "Дата рождения от",
      BIRTHDAY_TO: "до даты",
      ITEMS_PER_PAGE: "Элементов на странице",
      PHONE_COPY: "Копировать номер",
      COPY_PHONE: "Копировать номер",
      DELETE_CONTACT_GROUP: "Удалить контакт из группы",
      DELETE_FROM_GROUP_ONLY: "Контакт удаляется только из этой группы",
      DELETE_FROM_ALL_GROUPS: "Контакт удаляется из всех групп",
      USER: "Пользователь",
      PHOTO: "Фото",
      FULL_NAME: "Имя и фамилия",
      EMAIL: "Эл. почта",
      PHONE_NUMBER: "Номер телефона",
      JOB_TITLE_COMPANY: "Должность и компания",
      CREATED_AT: "Время создания",
      PHONEBOOK: "Телефонная книга",
      ACTIONS: "Действия",
    },
    TITLE: "Заголовок",
    SEARCH_IN_TITLE: "Поиск по заголовку",
    FROM: "От",
    TO: "До",
    BIRTHDAY_FROM: "Дата рождения от",
    BIRTHDAY_TO: "до даты",
    ITEMS_PER_PAGE: "Элементов на странице",
    PHONE_COPY: "Копировать номер",
    COPY_PHONE: "Копировать номер",
    DELETE_CONTACT_GROUP: "Удалить контакт из группы",
    DELETE_FROM_GROUP_ONLY: "Контакт удаляется только из этой группы",
    DELETE_FROM_ALL_GROUPS: "Контакт удаляется из всех групп",
    USER: "Пользователь",
    PHOTO: "Фото",
    FULL_NAME: "Имя и фамилия",
    EMAIL: "Эл. почта",
    PHONE_NUMBER: "Номер телефона",
    JOB_TITLE_COMPANY: "Должность и компания",
    CREATED_AT: "Время создания",
    PHONEBOOK: "Телефонная книга",
    ACTIONS: "Действия",
  },
  GRADUAL: {
    SEND_GRADUAL: "Пошаговая отправка",
    ALLOWED_HINT: "Для отправки более 500 номеров",
    SEND_GRADUAL_OPTION: "Отправлять постепенно",
    AFTER_EVERY: "После каждых",
    SEND_SMS: "сообщений отправлять?",
    TIME_INTERVAL: "Интервал времени",
    SMS_PART: "Количество SMS",
    SMS_PART_HINT: "Введите количество SMS в каждой партии.",
    COUNT_ERROR: "Количество SMS в партии не может быть меньше 500!",
  },
  HISTORY: {
    CREATE_NEW: "Создать новую историю",
    BACK: "Назад",
    TITLE: "Заголовок истории",
    STEP: "Этап",
    LAST_CALL: "Время последнего звонка",
    DISCUSSIONS: "Проведённые переговоры",
    REMIND_DATE: "Время напоминания",
    FOLLOWUP: "Пункты для отслеживания в следующем звонке",
    SAVE_HISTORY: "Сохранить историю",
    INDEX: "№",
    SAVED_BY: "Зарегистрировано",
    ACTION: "Управление",
    MORE_INFO: "Подробнее о",
    CREATE_ERROR: "Ошибка при добавлении истории клиента!",
  },
  FORMS: {
    SourceNumber: "Исходный номер",
    DestinationPhone: "Номер получателя",
    Add: "Добавить",
    SEND_TO_SELECTED_NUMBERS: "Отправить выбранным номерам",
    CHANGE_PATTERN_CAMPAIGN: "Изменить шаблон/кампанию",
    SendTime: "Время отправки",
    SELECTED_MESSAGE: "Выбранное сообщение",
    REQUIRED_INPUTS: "Обязательные поля",
    SELECTED: "Выбрано",
    ID: "ID",
    SEND: "Отправить",
    DATE_REQUIRED: "Выбор даты обязателен.",
    TIME_INTERVAL: "Интервал времени",
    TIME_INTERVAL_FROM_PREVIOUS: "Интервал от предыдущего сообщения",
    Title: "Заголовок",
    LINK: "Ссылка",
    LINK_HINT: "любой",
    LINK_PLACEHOLDER: "Пример:[](https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "Ваша ссылка после сокращения заменится на 14 символов (example.ex/any) в тексте, и для каждого сообщения будет отправлена уникальная ссылка.",
    Text: "Текст",
    MUST_INCLUDE_PATTERN: "Должно включать {pattern}",
    INVALID_LINK: "Введите корректную ссылку",
  },
  ERRORS: {
    VpnDetectedTitle: "Отключите VPN",
    VpnDetectedSubtitle:
      "Это позволит системе работать лучше, и вы получите лучший опыт.",
    PhoneIsNotValid: "Номер телефона недействителен",
    MaxPhoneLimit: "Вы не можете добавить более 50000 номеров.",
    NoSelectedLineNumber: "Не выбран исходный номер.",
    INVALID_TIMER: "Введите корректное время",
    NoAccess: "Нет доступа",
    PleaseBuyAPlane: "Пожалуйста, купите план",
    NoAccountCharge: "Недостаточно средств на счёте",
    PleaseChargeYourAccount: "Пожалуйста, пополните счёт",
    Unauthorized: "Нет доступа: пожалуйста, войдите снова",
    ServerError: "Произошла ошибка сервера, попробуйте позже",
    NetworkError: "Ошибка сети: проверьте подключение к интернету",
    InvalidInput: "Некорректный ввод",
    SessionExpired: "Сессия истекла, пожалуйста, войдите снова",
    TokenInvalid: "Недействительный токен",
    VpnDetected: "Ваш VPN включён, пожалуйста, отключите его",
    RequestTimeout: "Запрос истёк, попробуйте снова",
    DuplicateEntry: "Этот элемент уже зарегистрирован",
  },

  BUTTONS: {
    DELETE_NUMBERS: "Удалить номера",
    ADD_BULK: "Массовое добавление",
    FROM_FILE: "Из файла",
    More: "Больше",
    BuyAPlane: "Купить план",
    AccountCharge: "Пополнить счёт",
    OK: "ОК",
    Close: "Закрыть",
    Cancel: "Отмена",
    Retry: "Повторить",
    Login: "Войти",
    Logout: "Выйти",
    Save: "Сохранить",
    Submit: "Отправить",
  },
  GENERAL: {
    row: "№",
    id: "ID",
    back: "Назад",
    manage: "Управление",
    SENDING: "Отправляется",
    RELOAD: "Обновить",
    PRINT: "Печать",
    DELETE: "Удалить",
    SUBMIT: "Отправить",
    SUCCESSFULLY_ADDED: "Успешно добавлено",
    RELOAD: "Обновить",
    CANCEL: "Отмена",
    SUCCESSFULLY_DOWNLOADED: "Успешно скачано",
    Loading: "Загрузка...",
    NoData: "Данные не найдены",
    Welcome: "Добро пожаловать",
    Profile: "Профиль",
    Settings: "Настройки",
    Wallet: "Кошелёк",
    Dashboard: "Панель управления",
  },

  NOTICES: {
    Attention: "Обратите внимание",
    MinimumSendWarning:
      'При отправке SMS с номером "новостная рассылка" минимальное количество должно быть {{number}}.',
  },
  contactsTags: {
    select_group: "Выбрать группу",
    create_group: "Создать группу",
    search: "Поиск",
    add_group: "Добавить группу",
    enter_group_name: "Введите желаемое название",
    group_name: "Название группы",
    cancel: "Отмена",
    edit: "Редактировать",
    save: "Сохранить",
    loading_categories: "Загрузка категорий...",
    select_group_and_subgroup: "Выбрать группу и подгруппу",
    add_group_with_subgroups: "Добавить группу с подгруппами",
    add_group_only: "Добавить только выбранную группу",
    duplicate_name_error: "Имя уже существует",
    added_successfully: "Успешно добавлено.",
    confirm_delete_group: "Подтвердить удаление группы?",
    deleted_successfully: "Успешно удалено",
    edited_successfully: "Успешно отредактировано",
    group_added_successfully: "Выбранные группы успешно добавлены.",
    error_creating_group: "Ошибка при добавлении группы по умолчанию",
    create_default_group: "Создать группу по умолчанию",
    select_default_group: "Выбрать группу по умолчанию",
    add_custom_group: "Добавить группу с пользовательским названием",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "Добавить номер телефона",
    ADD: "Добавить",
    SHARE_ACCESS:
      "Выбрав любой из пунктов ниже, поделитесь нужным доступом с другими.",
    SELECT_ACCESS: "Выбрать доступ к телефонной книге",
    DELETE: "Удалить",
    EDIT: "Редактировать",
    SEND: "Отправить",
    PERSONS_WITH_ACCESS: "Лица с доступом",
    REMOVE_ACCESS: "Убрать доступ",
    RETURN: "Назад",
    SAVE_CHANGES: "Сохранить изменения",
    SHARE_CONTACT_BOOK: "Поделиться телефонной книгой",
    PHONE_VALIDATION: "Введите корректный номер телефона",
    SUCCESS_SHARE: "Телефонная книга успешно поделена.",
    ERROR_SHARE: "Ошибка при обмене телефонной книгой!",
    PHONE_DUPLICATE: "Номер уже добавлен!",
    CHANGES_SAVED: "Изменения успешно сохранены.",
    ERROR_SAVING_CHANGES: "Ошибка при сохранении изменений!",
  },
  CONTACT_SEARCH: {
    SEARCH: "Поиск",
    ADD_NUMBER: "Добавить номер",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "На странице",
    FROM: "От",
    TO: "До",
    TOTAL: "Всего",
  },
  SUCCESS: {
    DELETED: "Успешно удалено",
    SUCCESS: "Успех",
  },
  CONFIRM: {
    DELETE_BULK: "Удалить несохранённые номера?",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "Скопируйте свои номера и нажмите",
    COPY_LINK: "Копировать ссылку",
    COPY_NUMBER: "Копировать номер",
    SEE_PROFILE: "Посмотреть профиль",
  },
  CONTACT_EDIT: {
    EDIT: "Редактировать",
    DELETE: "Удалить",
  },
  CONTACT_MENU: {
    SHARE: "Поделиться",
    PRINT: "Печать",
    EXCEL_EXPORT: "Экспорт в Excel",
    DELETE: "Удалить",
    SUCCESS_DELETE: "Успешно удалено.",
    ERROR_DELETE: "Ошибка при удалении контактов!",
  },
  CONTACTS: {
    PREFIX: "Префикс",
    NAME: "Имя",
    MIDDLENAME: "Отчество",
    LASTNAME: "Фамилия",
    POSTFIX: "Суффикс",
    ALIAS: "Псевдоним",
    COMPANY: "Компания",
    JOBTITLE: "Должность",
    PHONE: "Телефон",
    PHONE_PLACEHOLDER: "Например: 8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "Добавить email",
    EMAIL: "Email",
    ADD_ADDRESS: "Добавить адрес",
    ADDRESS: "Адрес",
    PROVINCE: "Провинция",
    CITY: "Город",
    POSTALCODE: "Почтовый индекс",
    YEAR_OPTIONAL: "Год (необязательно)",
    MONTH: "Месяц",
    DAY: "День",
    ADD_BIRTHDAY: "Добавить дату рождения",
    ADD_WEBSITE: "Добавить сайт",
    WEBSITE: "Веб-сайт",
    ADD_DATE: "Добавить дату",
    DATE: "Дата",
    CUSTOM_FIELD: "Пользовательское поле",
    ADD_CUSTOM_FIELD: "Добавить пользовательское поле",
    NOTE: "Описание",
    ADD_NOTE: "Добавить заметку",
    HOME: "Дом",
    WORK: "Работа",
    OTHER: "Другое",
    PROFILE: "Профиль",
    BLOG: "Блог",
    HOMEPAGE: "Главная страница",
    TITLE: "Заголовок",
    BIRTHDAY_ERROR: "Введите дату корректно",
    YEAR_ERROR: "4 цифры",
    EMAIL_ERROR: "Введите email корректно",
    WEBSITE_ERROR: "Введите ссылку корректно (website.com)",
    PHONE_ERROR: "Введите корректный номер телефона",
    ADD_HISTORY: "Добавить историю",
    HISTORY_LIST: "Список историй",
    EDIT_CONTACT: "Редактировать контакт",
    SHOW_CONTACT: "Показать контакт",
  },
  MONTHS: {
    FARVARDIN: "Фарвардин",
    ORDIBEHESHT: "Ордибехешт",
    KHORDAD: "Хордад",
    TIR: "Тир",
    MORDAD: "Мордад",
    SHAHRIVAR: "Шахривар",
    MEHR: "Мехр",
    ABAN: "Абан",
    AZAR: "Азар",
    DEY: "Дей",
    BAHMAN: "Бахман",
    ESFAND: "Эсфанд",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "Скачать и использовать образец файла Excel",
    UPLOAD_TITLE: "Загрузка файла",
    DRAG_DROP_TEXT_PART1: "Перетащите для загрузки или",
    DRAG_DROP_TEXT_PART2: "здесь",
    DRAG_DROP_TEXT_PART3: "нажмите",
    FILE_INPUT_LABEL: "Загрузить файл Excel",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "Ссылка успешно скопирована!",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "Ошибка при копировании ссылки.",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "Выбор шаблона/кампании",
    BUTTON_EDIT_TEXT: "Изменить шаблон/кампанию",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "Зарегистрировать новый шаблон",
    REGISTER_NEW_CAMPAIGN: "Зарегистрировать новую кампанию",
    CREATE_NEW_HISTORY: "Создать новую историю",
    SAVE_HISTORY: "Сохранить историю",
    SELECT_GROUP: "Выбрать группу",
    CREATE_GROUP: "Создать группу",
    ADD_GROUP: "Добавить группу",
    SAVE: "Сохранить",
    CREATE_GROUP_SINGULAR: "Создать группу",
    ADD: "Добавить",
    SEND: "Отправить",
    EDIT_PERMISSIONS: "Редактировать",
    GO_BACK: "Назад",
    SAVE_CHANGES: "Сохранить изменения",
    GUIDE: "Руководство",
    START: "Начать",
    EDIT: "Редактировать",
    CANCEL: "Отмена",
    AUTO_REFRESH: "Автообновление",
    AUTO_REFRESH_SETTINGS: "Настройки автообновления",
    BACK: "Назад",
  },
  TABS: {
    SELECT_PATTERN: "Выбор шаблона",
    SELECT_CAMPAIGN: "Выбор кампании",
    LIST: "Список",
    ADD: "Добавить",
    ADD_CUSTOM_GROUP: "Добавить группу с пользовательским названием",
    SELECT_DEFAULT_GROUP: "Выбрать группу по умолчанию",
  },
  NO_DATA: {
    NO_PATTERN: "Шаблон не найден, сначала зарегистрируйте шаблон.",
  },
  TABLE: {
    ID: "ID",
    TYPE: "Тип",
    PATTERN: "Шаблон",
    STATIC: "Статический",
    TITLE: "Заголовок",
    TEXT: "Текст",
    STATUS: "Статус",
    REJECTED: "Отклонено",
    ACCEPTED: "Одобрено",
    NEXT_BUTTON: "Далее",
    PREVIOUS_BUTTON: "Назад",
    ROWS_PER_PAGE_TEXT: "Строк на странице",
    NO_DATA_TEXT: "Нет данных для отображения",
    PLACEHOLDER_SEARCH: "Поиск",
    MORE_INFO_ABOUT_ITEM: "Подробнее о {name}",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "Текст",
    SELECT_USER_INFO: "Выбрать данные пользователя",
  },
  TABLE_CONTROLS: {
    COUNT: "Количество",
    SEARCH: "Поиск",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "Название группы по умолчанию",
    PARENT_CATEGORY: "Родительская категория",
    HISTORY_TITLE: "Заголовок истории",
    STEP: "Этап",
    LAST_CALL_TIME: "Время последнего звонка",
    NEGOTIATIONS: "Проведённые переговоры",
    REMINDER_TIME: "Время напоминания",
    FOLLOW_UP_ITEMS: "Пункты для отслеживания в следующем звонке",
    GROUP_NAME: "Название группы",
    SEARCH: "Поиск",
    TITLE: "Заголовок",
    SEARCH_IN_TITLE: "Поиск по заголовку",
    FROM: "От",
    TO: "До",
    BIRTHDAY_FROM: "Дата рождения от",
    BIRTHDAY_TO: "до даты",
    COUNT: "Количество",
    ADD_PHONE_NUMBER: "Добавить номер телефона",
  },
  TOAST: {
    Success: "Операция успешно выполнена",
    Error: "Произошла ошибка",
    Warning: "Предупреждение: проверьте ввод",
    AUTO_REFRESH_STARTED: "Автообновление запущено.",
    DEFAULT_GROUP_SUCCESS: "Группа по умолчанию успешно добавлена.",
    DEFAULT_GROUP_ERROR: "Ошибка при добавлении группы по умолчанию!",
    ADD_HISTORY_ERROR: "Ошибка при добавлении истории клиента!",
    DUPLICATE_NAME: "Имя уже существует",
    TAG_ADDED_SUCCESS: "Тег успешно добавлен.",
    TAG_DELETED_SUCCESS: "Тег успешно удалён",
    TAG_EDITED_SUCCESS: "Тег успешно отредактирован",
    GROUPS_ADDED_SUCCESS: "Выбранные группы успешно добавлены.",
    ADD_GROUP_ERROR: "Ошибка при добавлении группы по умолчанию!",
    PHONE_COPIED_SUCCESS: "Номер телефона скопирован.",
    SUCCESSFULLY_DELETED: "Успешно удалено",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK:
      "Ошибка при удалении контакта из телефонной книги!",
    SHARE_SUCCESS: "Телефонная книга успешно поделена.",
    SHARE_ERROR: "Ошибка при обмене телефонной книгой!",
    NUMBER_ALREADY_ADDED: "Номер уже добавлен!",
    CHANGES_SAVED_SUCCESS: "Изменения успешно сохранены.",
    CHANGES_SAVE_ERROR: "Ошибка при сохранении изменений!",
  },
  HEADERS: {
    GRADUAL_SEND: "Пошаговая отправка",
    GRADUAL_SEND_HINT: "(для отправки более 500 номеров)",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "Отправлять постепенно",
    DELETE: "Удалить",
    EDIT: "Редактировать",
    ADD: "Добавить",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION: "После каждых {time} отправлять сообщения?",
  },
  LABELS: {
    TIME_INTERVAL: "Интервал времени",
    MESSAGE_COUNT: "Количество сообщений",
  },
  TIME_TYPES: {
    MINUTE: "минута",
    HOUR: "час",
    DAY: "день",
    WEEK: "неделя",
    SECOND: "секунда",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART: "Введите количество сообщений в каждой партии.",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT:
      "Количество сообщений в партии не может быть меньше 500!",
  },
  TABLE_HEADERS: {
    ROW: "№",
    TITLE: "Заголовок",
    STEP: "Этап",
    REMINDER_TIME: "Время напоминания",
    LAST_CALL_TIME: "Время последнего звонка",
    RECORDER: "Зарегистрировано",
    MANAGEMENT: "Управление",
    ID: "ID",
    GROUP_NAME: "Название группы",
    PARENT: "Родитель",
    CREATED_AT: "Создано",
    IMAGE: "Фото",
    FULL_NAME: "Имя и фамилия",
    EMAIL: "Эл. почта",
    PHONE_NUMBER: "Номер телефона",
    JOB_COMPANY: "Должность и компания",
    CREATION_TIME: "Время создания",
    PHONEBOOK: "Телефонная книга",
    ACTIONS: "Действия",
    USER: "Пользователь",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "Исходный номер",
  },
  MODAL: {
    INFO_TITLE: "Обратите внимание.",
    INFO_MESSAGE_NEWS_NUMBER:
      'При отправке SMS с номером "{number}" минимальное количество должно быть 1000.',
    CONFIRM_DELETE_GROUP: "Подтвердить удаление группы?",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "Новостная рассылка",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "Руководство системы",
    ERROR: "Ошибка",
    WARNING: "Предупреждение",
    SUCCESS: "Успех",
    CONFIRM: "Подтверждение",
    SELECT_GROUP: "Выбор группы",
    CREATE_NEW_GROUP: "Создать новую группу",
    SELECT_GROUP_SUBGROUP: "Выбор группы и подгруппы",
    CREATE_DEFAULT_GROUP: "Создать группу по умолчанию",
    DELETE_CONTACT_FROM_GROUP: "Удалить контакт из группы",
    DELETE_CONTACT: "Удалить контакт",
    SHARE_PHONEBOOK: "Поделиться телефонной книгой",
    SYSTEM_GUIDE: "Руководство системы рекламного терминала",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "Введите желаемое название",
    SELECT_PERMISSIONS: "Выбрать доступ к телефонной книге {name}:",
    PEOPLE_WITH_ACCESS: "Лица с доступом",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "Загрузка категорий...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "Добавить группу с подгруппами",
    SELECTED_GROUP_ONLY: "Добавить только выбранную группу",
    DELETE_FROM_THIS_GROUP_ONLY: "Удалить контакт только из этой группы",
    DELETE_FROM_ALL_GROUPS: "Удалить контакт из всех групп",
  },
  FILTER_LABELS: {
    ADDRESS: "Адрес",
    EMAIL: "Эл. почта",
    WEBSITE: "Веб-сайт",
    CUSTOM_FIELD: "Пользовательское поле",
    DATE: "Дата",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION:
      "Выбрав любой из пунктов ниже, поделитесь нужным доступом с другими.",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "Введите корректный номер телефона",
  },
  LIST_ITEM_TITLES: {
    DELETE: "Удалить",
    EDIT: "Редактировать",
    ADD: "Добавить",
    REMOVE_ACCESS: "Убрать доступ",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "Название кампании",
    TEXT: "Текст",
    MESSAGE: "Сообщение",
    FOR: "Для",
    SELECT_CAMPAIGN: "Выбрать кампанию",
    CLICK_ROW: "Нажмите на нужную строку.",
    NEW: "Новая",
    SUBMIT_CAMPAIGN: "Зарегистрировать кампанию",
    TIME: "Час",
    MESSAGE_COUNT: "Количество сообщений",
    PAGE_COUNT: "Общее количество сообщений (страница)",
    PAGE: "Страница",
    CANCEL_TEXT: "Отмена11",
    TRACKABLE_LINK: "Отслеживаемая ссылка",
    WARNING_TEXT: "Пожалуйста, исправьте текст(ы) выбранной кампании!",
    WARNING_TITLE: "Пожалуйста, исправьте заголовок(и) выбранной кампании!",
    WARNING_GAP: "Пожалуйста, исправьте интервал(ы) выбранной кампании!",
    WARNING_OPERATOR: "Пожалуйста, исправьте оператор(ы) выбранной кампании!",
    MAX_ITEMS_ERROR: "Максимум 10 элементов можно добавить.",
  },
  ADS: {
    LIVEolem_SMS: "Отправка живых SMS",
    BUY_JOB_DB: "Покупка базы данных профессий",
    SMART_LADDER: "Умная лестница объявлений Divar",
    JOB_SMS: "Отправка SMS профессиям",
    WEB_DESIGN: "Заказ дизайна сайта",
    SEO: "Заказ SEO сайта",
    MAP_SMS: "Отправка SMS с карты",
    GRADUAL_LADDER: "Пошаговая лестница объявлений Divar",
    SEO_ALT: "Заказ SEO сайта",
    SITE_SUPPORT: "Управление и поддержка сайта",
    CITY_SMS: "Отправка SMS по городу и провинции",
    AUTO_CHAT: "Автоматический чат Divar",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "Связь в WhatsApp",
    TICKET_SUPPORT: "Регистрация тикета",
  },
  INCREASE: {
    PAN: "Номер карты",
    CVV2: "CVV2",
    MONTH: "Месяц",
    YEAR: "Год",
    PIN2: "Второй пароль",
    GET_OTP: "Получить второй пароль",
    PAY: "Оплата",
    INVALID_PAN: "Номер карты некорректен",
    INVALID_CVV2: "CVV2 некорректен",
  },
  WALLET: {
    CustomCharge: "Пополнить кошелёк",
    withdrawTitle: "Вывод из кошелька",
    transactionListTooltip: "Список ваших транзакций",
    reloadTooltip: "Обновить",
    withdrawTooltip: "Вывод из кошелька",
    AmountLabel: "Сумма ",
    SelectAmount: "Выбрать сумму",
    Amount: "Сумма",
    Currency: "Риал",
    GateWay: "Платёжный шлюз",
    noGateWay: "Шлюз не найден",
    Pay: "Оплатить",
    PriceNotInRange: "Сумма должна быть между {min} и {max}.",
    ErrorOnRedirectToGateWay: "Ошибка при переходе к шлюзу оплаты",
    ErrorGeneral: "Ошибка",
    MinAmountError: "Введённая сумма меньше минимально допустимой.",
    MinBazarAmountError: "Сумма не может быть меньше 10 000 томанов!",
    BazarSuccessInfo:
      "При успешной оплате кошелёк пополнится через 1–3 минуты.",
    withdrawableBalance: "Доступный для вывода баланс",
    withdrawFee: "Комиссия за вывод: 50 000 риалов!",
    selectAccount: "Выбрать счёт",
    addAccount: "Добавить счёт",
    submitWithdraw: "Подтвердить вывод",
    accountRequiredInfo: "Все поля обязательны.",
    ownerName: "Имя владельца счёта",
    ownerLastName: "Фамилия",
    bankName: "Название банка",
    accountNumber: "Номер счёта",
    cardNumber: "Номер карты",
    sheba: "Номер ШЕБА",
    onlyPersian: "Только персидские буквы!",
    cardNumberLength: "Номер карты должен содержать 16 цифр!",
    shebaLength: "Номер ШЕБА должен содержать 24 цифры!",
  },
  USER_PICKER: {
    SELECT_USER: "Выбрать пользователя",
    SELECT_USERS: "Выбрать пользователей",
    SEARCH: "Поиск",
    PERSON: "Физическое лицо",
    COMPANY: "Юридическое лицо",
    ID: "ID",
    NAME: "Имя",
    LASTNAME: "Фамилия",
    USERNAME: "Имя пользователя",
    PHONE: "Номер телефона",
    TYPE: "Тип пользователя",
  },
  NEWS: {
    TITLE: "Новости SMS Land",
    VIEW_BUTTON: "Просмотреть",
    NO_NEWS: "Нет свежих новостей.",
    FETCH_ERROR: "Ошибка при получении новостей!",
  },
  MENUS: {
    CONTACT_LIST: "Список контактов",
    FINDPREFIX: "Поиск префикса",
    // Системы
    TICKET_REGISTRATION: "Регистрация тикета",
    AD_TERMINAL_SYSTEM: "Большая система рекламного терминала",
    WALLET_TRANSACTIONS: "Транзакции кошелька",
    DYNAMIC_QR_SYSTEM: "Система создания динамических QR",
    DIVAR_AD_SYSTEM: "Система размещения и управления объявлениями Divar",
    GRAPHIC_DESIGN_SYSTEM: "Система заказа графического дизайна и печати",
    DIGITAL_MARKETING_SYSTEM: "Система управления цифровым маркетингом",
    BULK_SMS_SYSTEM: "Система массовой отправки SMS",
    BUSINESS_INFO_SYSTEM: "Система базы данных профессий страны",
    AD_MANAGEMENT_SYSTEM: "Система управления рекламными объявлениями",
    GRAPHIC_VIDEO_SERVICES: "Система услуг графического дизайна и видео",
    // Инструменты QR
    QR_TOOL: "Инструмент QR",
    CREATE_DYNAMIC_QR: "Создать динамический QR",
    QR_MANAGEMENT: "Управление QR",
    QR_MONITORING: "Мониторинг QR-кодов",
    MY_QR_LIST: "Список моих QR",
    PHYSICAL_NFC_ORDERS: "Заказы физических карт и NFC",
    BULK_QR_GENERATION: "Массовое создание QR-кодов",
    IMAGE_CREATION_TOKEN: "Токен создания изображения",
    QR_SMS: "QR SMS",
    QR_LINK: "QR ссылка",
    QR_TEXT: "QR текст",
    QR_LOCATION: "QR местоположение",
    QR_EMAIL: "QR email",
    QR_CALL: "QR звонок",
    QR_WIFI: "QR Wi-Fi",
    VISIT_STATISTICS: "Статистика посещений",
    // Управление объявлениями
    AD_MONITORING: "Мониторинг объявлений",
    DIVAR_NEWS: "Новости Divar",
    REAL_ESTATE_AD_SUBMISSION: "Отправка объявлений панели недвижимости",
    AUTO_AD_RENEWAL: "Автоматическое продление объявлений",
    GRADUAL_AD_SUBMISSION: "Пошаговая отправка объявлений",
    SMART_AD_SUBMISSION: "Умная отправка объявлений",
    DEFAULT_AD_REGISTRATION: "Регистрация объявления по умолчанию",
    AD_ANALYZER: "Анализатор посещений объявления",
    ADD_AD_PHOTO: "Добавить фото объявления",
    SMART_LADDER: "Умная лестница",
    GRADUAL_LADDER: "Пошаговая лестница",
    ADS_LIST: "Список объявлений",
    AD_REPORTS: "Отчёты объявлений",
    SCHEDULED_AD_SUBMISSION: "Отправка объявлений по расписанию",
    SCHEDULED_AD_LIST: "Список объявлений по расписанию",
    PERSONAL_AD_SUBMISSION: "Личная отправка объявлений",
    TARGET_TOOLS: "Целевые инструменты",
    SMART_LIST: "Умный/пошаговый список",
    // SMS
    SEND_TO_CUSTOMER_CLUB: "Отправка в клуб клиентов",
    BULK_SMS: "Массовая отправка SMS",
    LIVE_SMS: "Отправка живых SMS (старая)",
    SEND_TO_BUSINESSES: "Отправка профессиям страны",
    SMS_BY_MAP: "Отправка SMS с карты",
    CITY_PROVINCE_SMS: "Отправка по городу и провинции",
    RECEIVED_SMS_LIST: "Список полученных SMS",
    SMS_TEXT_CONSULTANT: "Мониторинг консультанта текста SMS",
    DEFAULT_TEXT_CONSULTATION: "Текст по умолчанию + консультация",
    ADMIN_SMS_SUBMISSIONS: "Отправки админа",
    PENDING_SMS: "SMS, ожидающие подтверждения",
    ADMIN_RECEIVED_REPORT: "Отчёт полученных админом",
    PATTERN: "Шаблон/паттерн",
    SMS_REPORTS: "Отчёты отправок",
    DEDICATED_LINE_REQUESTS: "Запросы на выделенную линию",
    PHONEBOOK: "Телефонная книга",
    SMS_TARIFFS: "Тарифы SMS",
    LINE_CATEGORIES: "Категории линий",
    TARIFF_COEFFICIENTS: "Коэффициенты тарифов отправки",
    SEND_ADMIN_SMS: "Отправка SMS админа",
    // Номера и контакты
    ADD_NEW_NUMBER: "Добавить новый номер",
    NUMBERS: "Номера",
    USER_NUMBERS: "Номера пользователей",
    REGISTER_USER_NUMBER: "Зарегистрировать номер для пользователя",
    NUMBER_LIST: "Список моих номеров",
    CREATE_NUMBER_TARIFF: "Создать тариф номеров",
    NUMBER_TARIFF_LIST: "Список тарифов номеров",
    OTHER_TARIFF_LIST: "Список других тарифов",
    // Финансовое управление
    WALLET: "Новый кошелёк",
    TRANSFER_REQUESTS: "Запросы на вывод",
    DIVAR_PAYMENTS: "Платежи Divar",
    AUTO_PAYMENT: "Автоматический платёж",
    PAYMENTS: "Платежи",
    PAYMENT_GATEWAY: "Платёжный шлюз",
    BUY_CHARGE: "Покупка заряда",
    // Управление клиентами и пользователями
    CUSTOMERS: "Клиенты",
    CRM_CUSTOMERS: "CRM клиенты",
    CONTACT_LIST: "Контакт-помощник (спасибо за контакт)",
    USERS: "Список пользователей",
    USER_REQUESTS: "Запросы пользователей",
    PROFILE: "Профиль",
    USER_HISTORY_NOTIFICATIONS: "Уведомления истории пользователей",
    // Дизайн и контент
    WEBSITE_DESIGN_ORDER: "Заказ дизайна сайта",
    SEO_ORDER: "Заказ SEO сайта",
    BUY_INFO_DATABASE: "Покупка информационной базы",
    BUY_MOBILE_DATABASE: "Покупка базы мобильных номеров",
    PURCHASED_ARCHIVES: "Архивы покупок",
    FAVORITE_ARCHIVES: "Избранные архивы",
    UPLOAD_CENTER: "Центр загрузки",
    CONTENT: "Контент",
    // Управление и настройки
    MONITORING: "Мониторинг",
    MANAGEMENT: "Управление",
    SETTINGS: "Настройки",
    CATEGORIES: "Категории",
    DOMAINS: "Домены",
    REMINDERS: "Напоминания",
    AUTOMATIC_CREATION: "Автоматическое создание",
    PERMISSIONS: "Разрешения",
    ROLES: "Роли",
    MENUS: "Меню",
    CORE_MANAGEMENT: "Основное управление",
    WORK_REPORTS: "Управление отчётами о работе",
    WORK_REPORT_CREATE: "Отчёт о работе",
    DEPARTMENTS: "Отделы",
    DISCOUNTS: "Скидки",
    NOTIFICATIONS: "Уведомления",
    ADMIN_NOTIFICATIONS: "Уведомления админа",
    TICKET_MANAGEMENT: "Управление тикетами",
    USER_GUIDE: "Руководство пользователя",
    CAMPAIGN: "Кампания",
    MESSAGE_CATEGORIES: "Категории сообщений",
    REGISTERED_INFO_LIST: "Список зарегистрированной информации",
    TARIFFS: "Тарифы",
    INFORMATION_REGISTRATION: "Регистрация информации",
    UNCREATED_CARDS: "Несозданные карты",
    MODELS_LIST: "Список моделей",
    CREATE_DEFAULT_PRODUCT: "Создать продукт по умолчанию",
    EXCEL_FILES: "Файлы Excel",
    AUTO_CHATS: "Умный чат",
    AUTO_CHAT: "Автоматический чат",
    // Другие
    MY_FILES: "Мои файлы",
    CONSULTANTS: "Консультанты",
    ADD_DIVAR_NEWS: "Добавить новости Divar",
    BUY_PANEL: "Купить панель",
    PANELS: "Панели",
    CALL_MONITORING: "Мониторинг звонков",
    INFO_REVIEW: "Проверка информации",
    MESSAGES: "Сообщения",
    PERSONNEL: "Персонал",
    //qr
    QR_TOOL: "Инструмент QR",
    CREATE_DYNAMIC_QR: "Создать динамический QR",
    QR_MANAGEMENT: "Управление QR",
    QR_MONITORING: "Мониторинг QR-кодов",
    MY_QR_LIST: "Список моих QR",
    PHYSICAL_NFC_ORDERS: "Заказы физических карт и NFC",
    BULK_QR_GENERATION: "Массовое создание QR-кодов",
    IMAGE_CREATION_TOKEN: "Токен создания изображения",
    CATEGORIES: "Категории",
    CREATE_DEFAULT_PRODUCT: "Создать продукт по умолчанию",
    DOMAINS: "Домены",
    REMINDERS: "Напоминания",
    AUTOMATIC_CREATION: "Автоматическое создание",
    SEND_ADMIN_SMS: "Отправка SMS админа",
    UNCREATED_CARDS: "Несозданные карты",
    MODELS_LIST: "Список моделей",
    UPLOAD_CENTER: "Центр загрузки",
    INFORMATION_REGISTRATION: "Регистрация информации",
    TARIFFS: "Тарифы",
    REGISTERED_INFO_LIST: "Список зарегистрированной информации",
    //code
    personel: "Персонал",
    "workReports/create": "Отчёт о работе",
    "admin/user-guide": "Руководство пользователя",
    phonebook: "Клуб клиентов",
    contactlist: "Контакт-помощник (спасибо за контакт)",
    "contact/list": "Контакт-помощник (спасибо за контакт)",
    "admin/transferRequests": "Запросы на вывод",
    "admin/wallet": "Новый кошелёк",
    "admin/cdr": "Мониторинг звонков",
    "admin/campaign": "Кампания",
    "admin/message-categories": "Категории сообщений",
    "admin/customers": "CRM клиенты",
    "admin/notifications": "Уведомления админа",
    "admin/user-history/notifications": "Уведомления истории пользователей",
    "admin/messages": "Сообщения",
    profile: "Профиль",
    "admin/workReports": "Управление отчётами о работе",
    panel: "Купить панель",
    adminDiscounts: "Скидки",
    departments: "Отделы",
    adminTickets: "Управление тикетами",
    "admin/configs": "Настройки",
    notifications: "Уведомления",
    "user/confirmed": "Запросы пользователей",
    users: "Список пользователей",
    payments: "Платёжный шлюз",
    permission: "Разрешения",
    panels: "Панели",
    category: "Меню",
    content: "Контент",
    role: "Роли",
    "core/admin": "Основное управление",
    //robot
    numberList: "Список моих номеров",
    registerAd: "Зарегистрировать объявление",
    proPanelSendAd: "Отправить объявление с профессиональной панели",
    buyCharge: "Купить заряд",
    scheduledAdSend: "Отправка объявления по расписанию",
    smartGradual: "Умный/пошаговый",
    createNumberTariff: "Создать тариф номеров",
    numberTariffList: "Список тарифов номеров",
    otherTariffList: "Список других тарифов",
    userNumbers: "Номера пользователей",
    numbers: "Номера",
    management: "Управление",
    settings: "Настройки",
    registerUserNumber: "Зарегистрировать номер для пользователя",
    divarPayments: "Платежи Divar",
    autoPayment: "Автоматический платёж",
    adAnalyzer: "Анализатор посещений объявления",
    infoReview: "Проверка информации",
    rb_payments: "Платежи",
    autoChat: "Автоматический чат",
    ads: "Объявления",
    monitoring: "Мониторинг",
    smartLadder: "Умная лестница",
    gradualLadder: "Пошаговая лестница",
    excelFiles: "Файлы Excel",
    autoChats: "Умный чат",
    addAdPhoto: "Добавить фото объявления",
    targetTools: "Целевые инструменты",
    smartList: "Умный/пошаговый список",
    scheduledAdList: "Список объявлений по расписанию",
    adsList: "Список объявлений",
    adReports: "Отчёты объявлений",
    personalAdSend: "Личная отправка объявлений",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "Введите желаемое время:",
    SUBTITLE:
      "После установки времени эта страница будет обновляться в выбранное время.",
    TIME_LABEL: "Время",
  },
  MODAL: {
    OK_TITLE: "Подтвердить",
  },

  ROUTE: {
    TITLES: {
    QR_NAME_EDIT_TEXT: "Редактировать текст QR",
    SERVER_DOWN: "Обновление системы",
    CREATE_MEMORIES_MODEL: "Создать шаблон рамки воспоминаний",
    CREATE_CARD_VISIT_PRO_MODEL: "Создать шаблон визитки Pro",
    CREATE_PRODUCT_PRO_MODEL: "Создать шаблон презентации товара Pro",
    CREATE_PRODUCT_LABEL_MODEL: "Создать шаблон этикетки товара",
    CREATE_PHOTO_GALLERY_MODEL: "Создать шаблон фотогалереи",
    CREATE_PDF_GALLERY_MODEL: "Создать шаблон галереи PDF",
    CREATE_SOCIAL_MEDIA_MODEL: "Создать шаблон соцсетей",
    EDIT_CARD_VISIT_PRO_MODEL: "Редактировать шаблон визитки Pro",
    EDIT_PRODUCT_PRO_MODEL: "Редактировать шаблон презентации товара Pro",
    EDIT_PRODUCT_LABEL_MODEL: "Редактировать шаблон этикетки товара",
    EDIT_PHOTO_GALLERY_MODEL: "Редактировать шаблон фотогалереи",
    EDIT_PDF_GALLERY_MODEL: "Редактировать шаблон галереи PDF",
    EDIT_SOCIAL_MEDIA_MODEL: "Редактировать шаблон соцсетей",
    BOOK: "Книга",
    NFC_LIST: "Список NFC",
    API_KEY_MANAGER: "Создать ключ API",
    PRE_PURCHASE: "Предзаказ",
    PRE_PURCHASE_MODEL: "Готовый шаблон",
      "QR_NAME_EDIT_GIFT": "Редактировать QR-код подарка",
  "QR_GIFT": "QR-код подарка",
      QR_CARD_VISIT_PRO:"QR-код ссылки Pro",
      "QR_NAME_EDIT_PRO": "Изменить QR-код ссылки Pro",
       "QR_LINK_EDIT_PRO": "Редактировать QR-код SEO Click Assistant",
  "QR_LINK_PRO": "QR-код SEO Click Assistant",
      DIGI: "Мониторинг ценообразования Digikala",
      QR_PDF: "Галерея PDF",
      QR_NAME_EDIT_PDF: "Редактирование галереи PDF",
      QR_MULTICART: "Мульти-QR карта",
      QR_MULTICART_EDIT: "Редактирование мульти-QR карты",
      QR_PRODUCTPRO: "Представление продукта (Про)",
      QR_NAME_PRODUCTPRO: "Редактирование представления продукта (Про)",
      QR_NAME_EDIT_CATALOG: "Редактирование каталога",
      QR_LUCK_WHEEL_Edit: "Редактировать колесо удачи",
      QR_LUCK_WHEEL: "Создать QR-код для колеса удачи",
      DASHBOARD: "Панель управления",
      ADMIN_QR_DOMAINS: "Мониторинг доменов",
      ADMIN_TOGETHER_TOKEN: "Мониторинг токенов",
      ADMIN_QR_SMS: "Отправка SMS",
      MENU_PROFILE_INFO: "Информация пользователя",
      MENU_PROFILE_SETTING: "Настройки профиля",
      MENU_PROFILE_ORDERS: "Заказы",
      MENU_PROFILE_ADDRESSES: "Адреса",
      QR_MONITORING: "Мониторинг QR",
      QR_LIST: "Список моих QR",
      QR_NAME_LIST: "Управление участием",
      QR_GENERATE_MULTIPLE: "Массовое создание QR-кодов",
      QR_CARD_VISIT: "Создание визитной карточки",
      HELP_INFO: "Тест кнопки",
      QR_MENU: "Меню магазина",
      QR_APPOINTMENT: "Запись",
      QR_INSURANCE: "Создание онлайн-страхования",
      QR_BPAGE: "Создание бизнес-страницы",
      QR_CPAGE: "Создание сайта торгового/административного комплекса",
      QR_BSHOP: "Онлайн-магазин",
      QR_NAME_EDIT_BSHOP: "Редактирование онлайн-магазина",
      QR_LINK_EDIT: "Редактирование ссылки",
      QR_NAME_DESIGN: "Редактирование дизайна",
      QR_NAME_SETTING: "Редактирование настроек",
      QR_NAME_EDIT: "Редактирование визитной карточки",
      QR_NAME_EDIT_BPAGE: "Редактирование бизнес-страницы",
      QR_EDIT_CPAGE: "Редактирование сайта комплекса",
      QR_NAME_INSURANCE: "Редактирование онлайн-страхования",
      QR_NAME_EDIT_MENU: "Редактирование меню",
      QR_NAME_EDIT_APPLICATION: "Предоставление приложения",
      QR_NAME_EDIT_APPOINTMENT: "Редактирование записи",
      QR_NAME_EDIT_PHOTO: "Редактирование галереи фото",
      QR_NAME_EDIT_VIDEO: "Редактирование галереи видео",
      QR_NAME_EDIT_VOICE: "Редактирование аудиогалереи",
      QR_NAME_EDIT_FEEDBACK: "Редактирование галереи отзывов",
      QR_NAME_CONSULTATION_QR_EDIT: "Редактирование формы заявки",
      QR_NAME_EDIT_VOICE_PRO: "Редактирование аудиогалереи (про)",
      QR_NAME_EDIT_SOCIAL: "Редактирование социальных сетей",
      QR_NAME_STATISTICS: "Статистика QR-кода",
      QR_CATE: "Выбор категории",
      QR_SHARE: "Поделиться",
      QR_BUSINESS_SHOP: "Бизнес/магазин",
      QR_CO_ORGAN: "Компания/организация",
      QR_CONTACT: "Связь с клиентом",
      QR_NOTICES: "Уведомления",
      QR_OTHERS: "Прочее",
      QR_STATICS: "Статический QR",
      QR_DYNAMICS: "Динамический QR",
      QR_D_BUSINESS: "Динамический бизнес QR",
      QR_D_ORGANS: "Динамический организационный QR",
      QR_D_GOVERNMENT: "Динамический государственный QR",
      QR_VIDEO: "Видеогалерея",
      QR_APPLICATION: "Предоставление приложения",
      QR_VOICE: "Аудиогалерея",
      QR_VOICE_PRO: "Аудиогалерея (про)",
      QR_CONSULTATION_QR: "Форма заявки",
      QR_FEEDBACK: "Галерея отзывов",
      QR_PHOTO: "Фотогалерея",
      QR_CATALOG: "Каталог / брошюра",
      QR_LOCATION: "Создание QR местоположения",
      QR_SOCIAL_MEDIA: "Создание QR социальной сети",
      QR_LINK: "Создание ссылки",
      QR_TEXT: "Создание текста",
      QR_MAIL: "Создание email",
      QR_CALL: "Звонок",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Веб-сайт",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "Бизнес-страница",
      QR_DISCOUNT: "Страница скидок",
      QR_PRODUCT_SHOP: "Представление продукта",
      QR_PRODUCT_LABEL: "Метка продукта",
      QR_GOLD_LABEL: "Золотая метка",
      QR_PRODUCT_TEMPLATE: "Продукты",
      ADMIN_CATEGORY: "Категории",
      QR_NFC_ORDERS: "NFC-карты, ожидающие подтверждения",
      QR_NAME_PRODUCT: "Редактирование представления продукта",
      QR_NAME_LABELPRODUCT: "Редактирование метки продукта",
      QR_NAME_GOLDPRODUCT: "Редактирование золотой метки",
      QR_COINS: "Криптовалюты",
      QR_SHOP: "Управление магазином",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Центр загрузки",
      PRICING: "Тарифы QR",
      QR_CREATE_MODELS: "Создание модели визитной карточки",
      QR_CREATE_BUSINESS_MODELS: "Создание модели бизнес-страницы",
      QR_CREATE_PRODUCT_MODEL: "Создание модели карточки продукта",
      QR_CREATE_MENU_MODELS: "Создание модели меню магазина",
      QR_CREATE_SHOP_MODEL: "Создание модели онлайн-магазина",
      MODELS_LIST: "Типы моделей QR",
      MODELS_LIST_EDIT: "Редактирование модели",
      MODELS_LIST_MENU_EDIT: "Редактирование модели меню",
      MODELS_LIST_BMODEL_EDIT: "Редактирование модели онлайн-магазина",
      NFC: "NFC-карты",
      SUBMIT_FORM: "Регистрация блогера",
      REQUEST_LIST: "Список блогеров",
      PURE_DATA: "Список несозданных визитных карточек",
      AUTO_CREATE: "Автоматическое создание QR",
      QR_CREATE: "Создание QR",
      HISTORY_REMINDER: "Мониторинг напоминаний",
      BOOK: "Мониторинг напоминаний"
    },
  },
  qr_management: "Управление QR",
  router: {
    dashboard: "Панель управления",
    contacts: "Клуб клиентов",
    editContact: "Редактировать клиента",
    createContact: "Создать клиента",
    customers: "Список клиентов",
    contactList: "Контакт-помощник",
    messages: "Сообщения",
    messageCategories: "Категории сообщений",
    oldTransactions: "Старые транзакции",
    yourTransactions: "Ваши транзакции",
    buyPanel: "Купить панель",
    permissions: "Доступы",
    createPermission: "Создать разрешение",
    invitations: "Список моих приглашений",
    editUser: "Редактировать пользователя",
    userInformation: "Просмотр информации пользователя",
    walletEdit: "Редактирование информации кошелька пользователя",
    userHistory: "История пользователя",
    userNotificationsHistory: "История уведомлений пользователей",
    notifications: "Уведомления",
    createNotification: "Создать уведомление",
    editNotification: "Редактировать уведомление",
    adminNotifications: "Уведомления админа",
    yourNotifications: "Ваши уведомления",
    adminNotificationsList: "Список уведомлений админа",
    tickets: "Тикеты",
    createTicket: "Зарегистрировать новый тикет",
    editTicket: "Редактировать тикет",
    departments: "Отделы",
    createDepartment: "Новый отдел",
    editDepartment: "Редактировать отдел",
    adminTickets: "Управление тикетами",
    discounts: "Скидки",
    createDiscount: "Создать скидку",
    editDiscount: "Редактировать скидку",
    workReports: "Отчёт о работе",
    createWorkReport: "Создать отчёт о работе",
    callMonitoring: "Мониторинг звонков",
    adminWorkReports: "Управление отчётами о работе",
    editWorkReport: "Просмотр и редактирование отчёта о работе",
    packProperties: "Свойства пакета",
    createPackProperty: "Создать свойство пакета",
    editPackProperty: "Редактировать свойство пакета",
    panels: "Панели",
    createPanel: "Создать панель",
    editPanel: "Редактировать панель",
    transferRequests: "Запросы на вывод",
    editTransferRequest: "Редактировать запрос на вывод",
    tariffs: "Тарифы",
    createTariff: "Создать тариф",
    editTariff: "Редактировать тариф",
    requests: "Запросы",
    viewUser: "Просмотр пользователя",
    manageTransactions: "Управление транзакциями",
    viewTransaction: "Просмотр транзакции",
    manageConfigs: "Управление настройками",
    rbLandConfigs: "Управление настройками Robot Land",
    editConfig: "Редактировать настройки",
    manageUsers: "Управление пользователями",
    categories: "Категории",
    createCategory: "Добавить категорию",
    editCategory: "Редактировать категорию",
    content: "Контент",
    createContent: "Добавить контент",
    editContent: "Редактировать контент",
    addUserGuide: "Добавить руководство пользователя",
    editUserGuide: "Редактировать руководство пользователя",
    roles: "Роли",
    editRole: "Редактировать роль",
    createRole: "Добавить роль",
    permissionTitle: "Доступы", // For cruds.permission.title
    paymentGateways: "Платёжные шлюзы",
    editPaymentGateway: "Редактировать платёжный шлюз",
    campaigns: "Кампании",
    createCampaign: "Создать кампанию",
    editCampaign: "Редактировать информацию кампании",
    adminCustomers: "Клиенты",
    createCustomer: "Создать клиентов",
    editCustomerInfo: "Редактировать информацию клиента",
    referrerCustomers: "Клиенты-реферы",
    customerHistory: "История клиента",
    userProfile: "Профиль пользователя",
    editProfile: "Редактировать профиль",
    inviteFriends: "Пригласить друзей",
    personalInfo: "Личная информация",
    editPersonalInfo: "Редактировать информацию",
    changePassword: "Сменить пароль",
    newWallet: "Новый кошелёк",
  },
  ticket: {
    text: "Зарегистрировать тикет",
  },
};
